import type { ReactElement } from 'react';
import { useUIDSeed } from 'react-uid';

import useAddresses from 'hooks/useAddresses';

import SkeletonLine from 'components/shared/skeletons/SkeletonLine';
import DeliveryAddressCard from './DeliveryAddressCard';
import AddAddressCard from './AddAddressCard';

type SProps = { isPrimary: boolean; };

function DeliveryAddressSkeleton({ isPrimary = false }: SProps): ReactElement {
  return (
    <div className="col-12 col-sm-6 col-lg-4 c-profile__address-item">
      <div className="c-profile__address-card ">
        <div className="c-profile__address-card-content">
          {isPrimary && (
            <h2 className="c-profile__address-card-heading">
              Primary Address
            </h2>
          )}

          <SkeletonLine width={140} height={14} />
          <br />
          <SkeletonLine width={160} height={14} />
          <br />
          <SkeletonLine width={180} height={14} />
          <br />
          <SkeletonLine width={120} height={14} />
        </div>

        <div className="c-profile__address-card-actions">
          <SkeletonLine width={60} height={14} />
        </div>
      </div>
    </div>
  );
}

type Props = { className?: string; };

function DeliveryAddressesCard({ className }: Props): ReactElement {
  const { addresses, reload } = useAddresses();
  const seed = useUIDSeed();

  const handleReload = () => {
    reload();

    setTimeout(() => {
      document.body.scrollIntoView({ behavior: 'smooth' });
    });
  };

  return (
    <div className={`col-12 c-profile__address-payments-wrapper ${className}`}>
      <div className="c-card c-profile__card">
        <div className="c-card__content">
          <h2 className="c-profile__card-heading">
            Delivery Addresses
          </h2>

          <div className="row c-profile__addresses-list">
            {addresses ? (
              <>
                {addresses.map((address) => (
                  <DeliveryAddressCard
                    address={address}
                    onUpdate={() => handleReload()}
                    onDelete={() => handleReload()}
                    key={address.id}
                  />
                ))}

                <AddAddressCard
                  isHidden={!addresses.length}
                  onAdd={() => handleReload()}
                />

                {!addresses.length && (
                  <div className="col-12">
                    No delivery addresses saved.
                  </div>
                )}
              </>
            ) : (
              [...Array(3)].map((el, i) => (
                <DeliveryAddressSkeleton
                  isPrimary={i === 0}
                  key={seed(i)}
                />
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeliveryAddressesCard;
